import { TApiOrder } from "../../../api/endpoints/Order";
import React, { Fragment } from "react";
import OrderListItem from "./OrderListItem";

export interface IFolder {
  id: number | null;
  name: string
}

interface IProps {
  currentFolderId: number | null;
  orders: Array<TApiOrder>;
  availableFolders: Array<IFolder>;
}

const OrderList = (props: IProps) => {
  const { orders, availableFolders, currentFolderId } = props;

  return (
    <Fragment>
      {
        orders.map(item =>
          <OrderListItem key={item.id} order={item} currentFolderId={currentFolderId}
                         availableFolders={availableFolders} />
        )
      }
    </Fragment>
  );
};

export default OrderList;
